import { render, staticRenderFns } from "./HomeBodyFirst.vue?vue&type=template&id=0d68fcea&scoped=true"
import script from "./HomeBodyFirst.vue?vue&type=script&lang=js"
export * from "./HomeBodyFirst.vue?vue&type=script&lang=js"
import style0 from "./HomeBodyFirst.vue?vue&type=style&index=0&id=0d68fcea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d68fcea",
  null
  
)

export default component.exports